import React from 'react';
import { Grid, Typography } from '@mui/material';

// Helper function to format garage rate data
const formatGarageRateDisplay = (additionalInfo) => {
  const { garageRateType, garageRateConfig } = additionalInfo || {};
  
  if (!garageRateType || !garageRateConfig) return {};

  const displayConfig = {};
  displayConfig['Pricing Model'] = garageRateType === 'per_km' ? 'Per Kilometer' : 
                                  garageRateType === 'slab' ? 'Slab Based' : 
                                  garageRateType === 'flat_rate' ? 'Flat Rate' : 
                                  garageRateType;

  switch (garageRateType) {
    case 'per_km':
      if (garageRateConfig.rate_per_km) {
        displayConfig['Rate Per KM'] = `₹${garageRateConfig.rate_per_km}`;
      }
      if (garageRateConfig.minimum_fare) {
        displayConfig['Minimum Fare'] = `₹${garageRateConfig.minimum_fare}`;
      }
      break;
    
    case 'slab':
      if (garageRateConfig.slabs && Array.isArray(garageRateConfig.slabs)) {
        garageRateConfig.slabs.forEach((slab, index) => {
          const slabKey = `Slab ${index + 1} (${slab.minKm}-${slab.maxKm} KM)`;
          displayConfig[slabKey] = `₹${slab.rate}/KM`;
        });
      }
      break;
    
    case 'flat_rate':
      if (garageRateConfig.flat_amount) {
        displayConfig['Flat Rate'] = `₹${garageRateConfig.flat_amount}`;
      }
      break;
  }

  return displayConfig;
};

// Slab Rate Table Component
const SlabRateTable = ({ slabs }) => (
  <Grid container className="mb20">
    <Grid item xs={12}>
      <Typography className="mb10 text-base font-semibold">Rate Slabs</Typography>
    </Grid>
    {/* Table Header */}
    <Grid container item xs={12} className="gridBorder fw600">
      <Grid item xs={6} className="gridBorder">
        <Typography variant="body2" className="colorGrey fw600 p20">
          Distance Range (KM)
        </Typography>
      </Grid>
      <Grid item xs={6} className="gridBorder">
        <Typography variant="body2" className="colorGrey fw600 p20">
          Rate per KM
        </Typography>
      </Grid>
    </Grid>
    {/* Table Rows */}
    {slabs.map((slab, index) => (
      <Grid container item xs={12} key={index} className="gridBorder">
        <Grid item xs={6} className="gridBorder">
          <Typography variant="body2" className="colorBlack fw400 p20">
            {slab.minKm} - {slab.maxKm} KM
          </Typography>
        </Grid>
        <Grid item xs={6} className="gridBorder">
          <Typography variant="body2" className="colorBlack fw400 p20">
            ₹{slab.rate}
          </Typography>
        </Grid>
      </Grid>
    ))}
  </Grid>
);

// Main Garage Rate Display Component
const GarageRateDisplay = ({ additionalInfo }) => {
  const { garageRateType, garageRateConfig } = additionalInfo || {};
  
  // For slab-based rates, show dedicated table
  if (garageRateType === 'slab' && garageRateConfig?.slabs) {
    return (
      <>
        <Grid container className="mb20">
          <Grid container item xs={12} lg={6}>
            <Grid item xs={4} className="gridBorder">
              <Typography variant={'body2'} className="colorGrey fw400 p20">
                Pricing Model
              </Typography>
            </Grid>
            <Grid item xs={8} className="gridBorder">
              <Typography variant={'body2'} className="colorBlack fw400 p20">
                Slab Based
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        
        {/* Dedicated slab table */}
        <SlabRateTable slabs={garageRateConfig.slabs} />
      </>
    );
  }
  
  // For other rate types, use existing grid
  return (
    <Grid container className="mb20">
      {Object.entries(formatGarageRateDisplay(additionalInfo)).map(([key, value], index) => (
        <Grid container item xs={12} lg={6} key={index}>
          <Grid item xs={4} className="gridBorder">
            <Typography variant={'body2'} className="colorGrey fw400 p20">
              {key}
            </Typography>
          </Grid>
          <Grid item xs={8} className="gridBorder">
            <Typography variant={'body2'} className="colorBlack fw400 p20">
              {value}
            </Typography>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default GarageRateDisplay;
